import { render, staticRenderFns } from "./NumberStepperInput.vue?vue&type=template&id=80b678a6"
import script from "./NumberStepperInput.vue?vue&type=script&lang=js"
export * from "./NumberStepperInput.vue?vue&type=script&lang=js"
import style0 from "./NumberStepperInput.vue?vue&type=style&index=0&id=80b678a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports